import React from 'react';
import BarraEmpilhada from './BarraEmpilhada';
import { formataNumero, formataPct } from './formata';

// Barra de destaque do topo: o total dividido em duas partes, com rótulo nas
// duas pontas. Responde "quanto é força" em um olhar.
export default function BarraComposicaoTotal({ a, b, series }) {
  const total = (a || 0) + (b || 0);
  return (
    <div>
      <BarraEmpilhada partes={[a, b]} series={series} max={total} hero />
      <div className="d-flex justify-content-between mt-1" style={{ fontSize: '.9rem' }}>
        <span>
          <strong style={{ color: series[0].cor }}>{formataNumero(a)}</strong> {series[0].rotulo.toLowerCase()} · {formataPct(a, total)}
        </span>
        <span className="text-muted">
          {formataNumero(b)} {series[1].rotulo.toLowerCase()} · {formataPct(b, total)}
        </span>
      </div>
    </div>
  );
}
